<app-breadcrumb [title]="page_name" [breadcrumb]="page_name"></app-breadcrumb>
<!-- section start -->
<section class="register-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="theme-card">
                    <h3 class="title">{{'register' | translate}}</h3>
                    <form class="theme-form">
                        <div class="form-row">
                            <div class="col-md-12 errorOccurred" *ngIf="errorOccurred">
                                {{errorOccurredMessage}}
                                <br>
                                <br>
                            </div>
                            <div class="col-md-6">
                                <label for="user_name">{{'Full Name' | translate}}</label>
                                <input type="text" class="form-control" id="user_name" placeholder="{{'Full Name' | translate}}" name="user_name" [(ngModel)]="user_name" required="required">
                                <span class="errorOccurred" *ngIf="successUser_name">{{errorUserNameMessage}} <br></span>
                            </div>
                            <div class="col-md-6">
                                <label for="mobile">{{'mobile' | translate}}</label>
                                <input type="tel" class="form-control" id="mobile" placeholder="{{'mobile' | translate}}" name="mobile" [(ngModel)]="mobile" required="required">
                                <span class="errorOccurred" *ngIf="successMobile">{{errorMobileMessage}} <br></span>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="email">{{'Email' | translate}}</label>
                                <input type="email" class="form-control" id="email" placeholder="{{'Email' | translate}}" name="email" [(ngModel)]="email" required="required">
                                <span class="errorOccurred" *ngIf="successEmail">{{errorSuccessEmailMessage}} <br></span>
                            </div>
                            <div class="col-md-6">
                                <label for="password">{{'Password' | translate}}</label>
                                <input type="password" class="form-control" id="password" placeholder="{{'Password' | translate}}" name="password" [(ngModel)]="password" required="required">
                                <span class="errorOccurred" *ngIf="successPassword">{{errorPasswordMessage}} <br></span>
                            </div>
                            <button class="btn btn-solid" (click)="userSignUp()">{{'create Account' | translate}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->